import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getStoredData } from "../../utils/localStorage";

function StepFooter() {
  const navigate = useNavigate();
  const location = useLocation();

  const goToStep = (stepNumber) => {
    if (stepNumber === 1) {
      const stored = getStoredData();
      const qual_meio_transporte = stored?.qual_meio_transporte;
      const rota_selecionada = stored?.rota_selecionada;
      const cidades_trajeto = stored?.cidades_trajeto;

      const routes = {
        aviao: "/aviao",
        onibus: "/onibus",
        trem: "/trem",
        carro: "/carro",
        moto: "/moto",
      };

      const route = routes[qual_meio_transporte];

      if (
        cidades_trajeto != undefined &&
        (route === "/carro" || route === "/moto")
      ) {
        navigate("/cidades-trajeto");
        return;
      }

      if (
        rota_selecionada != undefined &&
        (route === "/carro" || route === "/moto")
      ) {
        navigate("/trajeto");
        return;
      }
      if (route) navigate(route);
    }

    if (stepNumber === 2) navigate("/data");
    if (stepNumber === 3) navigate("/espaco-disponivel");
    //if (stepNumber === 4) navigate("/informacao-a-viagem");
  };

  const getActiveStep = () => {
    const path = location.pathname;

    if (["/aviao", "/onibus", "/trem", "/cidades-trajeto"].includes(path))
      return 1;
    if (path === "/data") return 2;
    if (path === "/espaco-disponivel") return 3;
    //if (path === "/informacao-a-viagem") return 4;

    return 1;
  };

  const activeStep = getActiveStep();

  return (
    <>
      <style>{`
            .stepper-footer {
                margin-top: auto;
                left: 0;
                width: 100%;
                height: 60px; 
                background: linear-gradient(
                90deg, 
                #1a7fe7 0%,
                #19c4c9 40%
            );
                display: none;
                align-items: flex-end; 
                padding: 0 50px;
                color: #fff;
                z-index: 100;
            }

            .stepper-footer .step {
                flex: 1;
                height: 100%; 
                display: flex;
                flex-direction: column;
                justify-content: center;
                cursor: pointer;
                padding: 0 20px;
                position: relative;
                transition: all 0.3s ease;
            }

            .stepper-footer .step:hover {
                background: rgba(240, 240, 240, 0.5);
                color: #000;
            }

            .stepper-footer .step.active {
                background: #f0f0f0; 
                color: #353437;
                height: 100%;
                border-radius: 4px;
                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
                z-index: 10;
            }

            .stepper-footer .step.active strong {
                color: #000;
            }

            .stepper-footer .step.active p {
                color: #666;
                opacity: 1;
            }

            .stepper-nav-buttons {
                display: flex;
                align-items: center;
                gap: 15px;
                margin-left: 60px;
                padding-right: 40px;
                align-self: center;
            }

            .nav-btn {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: 1.5px solid #fff;
            background: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s;
            }

            .nav-btn:hover {
            background: rgba(255, 255, 255, 0.1);
            }

            .arrow {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-top: 2px solid #fff;
            border-right: 2px solid #fff;
            }

            .arrow.left {
            transform: rotate(-135deg);
            margin-left: 4px;
            }

            .arrow.right {
            transform: rotate(45deg);
            margin-right: 4px; 
            }

            @media (max-width: 934px) {
              .stepper-footer {
                height: auto;
                flex-direction: column;
                align-items: stretch;
                padding: 10px;
                gap: 8px;
              }

              .stepper-footer .step {
                flex: unset;
                width: 100%;
                padding: 10px;
                border-radius: 6px;
              }

              .stepper-footer .step.active {
                height: auto;
              }

              .stepper-footer .step strong {
                top: 0 !important;
                font-size: 14px;
              }

              .stepper-footer .step p {
                font-size: 12px;
              }

              .stepper-nav-buttons {
                margin: 10px 0 0 0;
                padding: 0;
                justify-content: center;
              }

              .nav-btn {
                width: 35px;
                height: 35px;
              }
            }

            @media (min-width: 935px) {
              .stepper-footer {
                position: fixed;
                bottom: 0;
                left: 0;
                width: 100%;
           
              }

           }

        `}</style>

      <div className="stepper-footer">
        <div
          className={`step ${activeStep === 1 ? "active" : ""}`}
          onClick={() => goToStep(1)}
        >
          <div>
            <strong style={{ fontSize: 18 }}> Passo 01:</strong> Origem e
            Destino
          </div>
        </div>

        <div
          className={`step ${activeStep === 2 ? "active" : ""}`}
          onClick={() => goToStep(2)}
        >
          <div>
            <strong style={{ fontSize: 18 }}> Passo 02:</strong> Data da Viagem
          </div>
        </div>

        <div
          className={`step ${activeStep === 3 ? "active" : ""}`}
          onClick={() => goToStep(3)}
        >
          <div>
            <strong style={{ fontSize: 18 }}> Passo 03:</strong> Tamanho da Mala
          </div>
        </div>

        {/*<div
          className={`step ${activeStep === 4 ? "active" : ""}`}
          onClick={() => goToStep(4)}
        >
          <strong style={{ position: "relative", top: 10 }}>Passo 04</strong>
          <p>Iinformação para a Viagem</p>
        </div>*/}

        <div className="stepper-nav-buttons">
          <button
            type="button"
            className="nav-btn"
            onClick={() => {
              if (activeStep > 1) goToStep(activeStep - 1);
            }}
          >
            <span className="arrow left"></span>
          </button>

          <button
            type="button"
            className="nav-btn"
            onClick={() => {
              if (activeStep < 4) goToStep(activeStep + 1);
            }}
          >
            <span className="arrow right"></span>
          </button>
        </div>
      </div>
    </>
  );
}

export default StepFooter;
